import type { Network } from '../types'

export { ARBITRUM } from './arbitrum'
export { AVALANCHE } from './avalanche'
export { BASE } from './base'
export { BERACHAIN } from './berachain'
export { BINANCECHAIN } from './binancechain'
export { CELO } from './celo'
export { GNOSIS } from './gnosis'
export { HYPERLIQUID } from './hyperliquid'
export { INK } from './ink'
export { KATANA } from './katana'
export { LINEA } from './linea'
export { MAINNET } from './mainnet'
export { MEGA_ETH } from './megaeth'
export { MONAD } from './monad'
export { OPTIMISM } from './optimism'
export { PLASMA } from './plasma'
export { POLYGON } from './polygon'
export { ROBINHOOD } from './robinhood'
export { SWELLCHAIN } from './swellchain'
export { UNICHAIN } from './unichain'
export { WORLDCHAIN } from './worldchain'

import { ARBITRUM } from './arbitrum'
import { AVALANCHE } from './avalanche'
import { BASE } from './base'
import { BERACHAIN } from './berachain'
import { BINANCECHAIN } from './binancechain'
import { CELO } from './celo'
import { ETHERLINK } from './etherlink'
import { GNOSIS } from './gnosis'
import { HYPERLIQUID } from './hyperliquid'
import { INK } from './ink'
import { KATANA } from './katana'
import { LINEA } from './linea'
import { MAINNET } from './mainnet'
import { MEGA_ETH } from './megaeth'
import { MONAD } from './monad'
import { OPTIMISM } from './optimism'
import { PLASMA } from './plasma'
import { POLYGON } from './polygon'
import { ROBINHOOD } from './robinhood'
import { SWELLCHAIN } from './swellchain'
import { UNICHAIN } from './unichain'
import { WORLDCHAIN } from './worldchain'

export const CHAINS = [
  MAINNET,
  OPTIMISM,
  ARBITRUM,
  POLYGON,
  GNOSIS,
  BASE,
  UNICHAIN,
  SWELLCHAIN,
  CELO,
  WORLDCHAIN,
  BERACHAIN,
  INK,
  BINANCECHAIN,
  HYPERLIQUID,
  PLASMA,
  AVALANCHE,
  KATANA,
  LINEA,
  MEGA_ETH,
  MONAD,
  ETHERLINK,
  ROBINHOOD,
] as const

export const CHAINS_BY_NAME = Object.fromEntries(CHAINS.map((chain) => [chain.name, chain])) as Record<
  Network,
  (typeof CHAINS)[number]
>
